export default __webpack_public_path__ + "static/media/M06.deb09809.svg";